import React from 'react';
import { HelpText as HelpTextNew } from './HelpText';
import { convertOldHelpTextProps } from './converter.old';
import type { OldHelpTextContent, OldHelpTextProps } from './converter.old';

export type HelpTextContent = OldHelpTextContent;
export type HelpTextProps = OldHelpTextProps;

export const HelpText: React.FC<HelpTextProps> = (props) => <HelpTextNew {...convertOldHelpTextProps(props)} />;
